import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Avatar, Spin, List } from 'antd';
import { longDateFormat, timeFormat } from 'utils/dates';
import { useDocument } from 'react-firebase-hooks/firestore';
import moment from 'moment';
import classNames from 'classnames';

import Client from 'containers/app/client';

import './style.css';

const BookingRow = ({ booking, user, profile }) => {
  const { id, dateStart, dateEnd, rate } = booking;
  const ref = Client.db.doc(`users/${user}`);
  const [doc, loading, error] = useDocument(ref);

  if (loading) return <Spin />;
  if (error) throw error;
  if (!doc.data()) return null;

  const { info } = doc.data();

  const startFormat = moment.utc(dateStart).format(longDateFormat);
  const endFormat = moment.utc(dateEnd).format(longDateFormat);
  const startTime = moment.utc(dateStart).format(timeFormat);
  const endTime = moment.utc(dateEnd).format(timeFormat);

  const days = moment(dateEnd).diff(moment(dateStart), 'days');
  const customClassName = classNames('booking-row');

  const title =
    days > 0 ? (
      <>
        <strong>{startFormat}</strong> - <strong>{endFormat}</strong>
      </>
    ) : (
      <>{startFormat}</>
    );

  const description =
    days > 0 ? (
      <span>
        Shift time <strong>{startTime}</strong>-<strong>{endTime}</strong>. With an hourly rate of <strong>£{rate}</strong>
      </span>
    ) : (
      <p>
        Shift time <strong>{startTime}</strong>-<strong>{endTime}</strong>. With an hourly rate of <strong>£{rate}</strong>
      </p>
    );

  return (
    <List.Item className={customClassName}>
      <List.Item.Meta
        avatar={
          <Link to={profile}>
            <Avatar size={60} src={info.photoURL} />
          </Link>
        }
        title={<Link to={`/booking-detail/${id}`}>{title}</Link>}
        description={description}
      />
    </List.Item>
  );
};

BookingRow.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.string,
    dateStart: PropTypes.string,
    dateEnd: PropTypes.string,
    rate: PropTypes.number,
  }).isRequired,
  user: PropTypes.string.isRequired,
  profile: PropTypes.string.isRequired,
};

export default BookingRow;
